import { Program } from '../../../programs/shared/program.model';
import {  Request } from '../model/request.model';
export class RequestReponse {
  nombreEstudiante: String;
  solicitud: Request;
  programa: Program;
}
